import { createTracker } from 'usage-tracker';
export const UsageTracker = createTracker({
  standalone: true,
  properties: {
    namespace: 'asset-actions-lib'
  }
});